import React, { useEffect, useState } from "react";
import { Ownership, Trade } from "../../types/types";
import {
  TableCell,
  TableRow,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Tabs,
  Tab,
  Box,
  Paper,
  Tooltip,
  Container,
} from "@mui/material";
import PlayerCardSimpleStats from "../Cards/PlayerCardSimpleStats";
import {
  GridColDef,
  GridCellParams,
  GridRowParams,
  GridEvents,
  MuiEvent,
  GridCallbackDetails,
  GridRenderCellParams,
} from "@mui/x-data-grid";
import PlayerDataGrid from "../DataGrid/PlayerDataGrid";
import GenericChangeAbleGraph from "../Graphs/GenericChangeAbleGraph";
import { CURRENT_SEASON } from "../../globals/BBLData";

export interface Props {
  ownerships: Ownership[];
  lastround: number;
}

const columns: GridColDef[] = [
  { field: "round", headerName: "Round", width: 180 },
  { field: "top100", headerName: "Top 100", width: 180 },
  { field: "top1000", headerName: "Top 1000", width: 180 },
  { field: "top5000", headerName: "Top 5000", width: 180 },
  { field: "top10000", headerName: "Top 10,000", width: 180 },
  { field: "top20000", headerName: "Top 20,000", width: 180 },
  { field: "top100000", headerName: "Top 100,000", width: 180 },
];

const PlayerOwnership = ({ ownerships, lastround }: Props) => {
  const [rows, setRows] = useState<object[]>([]);

  useEffect(() => {
    PopulateRows();
  }, [ownerships]);

  const PopulateRows = () => {
    let newrows: object[] = [];
    ownerships.map(function (ownership) {
      if (ownership.season === CURRENT_SEASON) {
        newrows.push({
          top100: ownership.top100 + "%",
          top1000: ownership.top1000 + "%",
          top5000: ownership.top5000 + "%",
          top10000: ownership.top10000 + "%",
          top20000: ownership.top20000 + "%",
          top100000: ownership.top100000 + "%",
          round: ownership.round,
          id: ownership.round,
        });
      }
    });

    setRows(newrows);
  };

  return (
    <div
      style={{
        marginTop: "2rem",
        display: "flex",
        flexDirection: "column",
        rowGap: "1rem",
      }}
    >
      <h4>Ownership %</h4>
      <Paper elevation={5} style={{ padding: "0.25rem" }}>
        <GenericChangeAbleGraph
          defaultGraphItems={["top1000"]}
          filteritems={[
            {
              name: "Ownership",
              options: [
                ["top100", "Top 100"],
                ["top1000", "Top 1,000"],
                ["top5000", "Top 5,000"],
                ["top10000", "Top 10,000"],
                ["top20000", "Top 20, 000"],
                ["top100000", "Top 100,000"],
              ],
            },
          ]}
          games={ownerships?.filter(
            (ownership) => ownership.season === CURRENT_SEASON
          )}
        />
      </Paper>
      <PlayerDataGrid rows={rows} columns={columns} height={"500px"} />
    </div>
  );
};

export default PlayerOwnership;
